export default __webpack_public_path__ + "static/media/fun_apr2020_pt3.38ac6eea.bmp";